const WORDS = ["Subscribe to the newsletter", "New releases in exclusivity"];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[var(--ink)] py-6 md:py-8">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((w, k) => (
          <span key={k} className="flex items-center">
            <span className={`font-display text-5xl font-extrabold uppercase md:text-7xl ${k % 2 ? "text-outline" : "text-[var(--bone)]"}`}>{w}</span>
            <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-[var(--gold)] md:mx-12" />
          </span>
        ))}
      </div>
    </div>
  );
}
